@let label = labelSg();
@let enumItems = enumItemsSg();
@let multiSelectValue = multiSelectValueSg();
@let enum = enumSg();

@if (enum?.inlineEnum?.isMultiselect) {
  <atn-ds-select-multiple
    [config]="{
      overlay: {
        minSearchCharacters: 1,
        hasSearch: true,
      },
    }"
    [label]="label"
    [items]="enumItems"
    [value]="multiSelectValue ?? []"
    (valueChange)="valueSg.set($event)"
  />
} @else {
  <atn-ds-select-single
    [config]="{
      overlay: {
        minSearchCharacters: 1,
        hasSearch: true,
      },
    }"
    [label]="label"
    [items]="enumItems"
    [(value)]="valueSg"
    [required]="requiredSg()"
  />
}
